import {Fragment} from "react";
import {Box} from "@mui/system";
import _ from "lodash";
import {supportedSourcesForCloseTicket} from "_constants";
import CircularProgress from "@mui/material/CircularProgress";
import ActionButton from "../../../../../common/ActionButton";
import TextButton from "../../../../../common/TextButton";
import PerfectResponseAction from "./PerfectResponseAction";
import CloseTicketCheckbox from "../../../../../common/CloseTicketCheckbox";
import TagEntry from "./Tag/TagEntry";
import {isTaggingSupported} from "./Tag/TagUtils";
import useViewActiveTags from "./Tag/hooks/useViewActiveTags";
import CustomFieldEntry from "./CustomField/CustomFieldEntry";

export default function ResponseActions({
    responseId,
    loadingHtmlBody,
    handleOpenEditor,
    isScrollComplete,
    handleCloseEditor,
    isEditingText,
    msgDataSource,
    canBeHidden,
    response,
    openEditor,
    handleSubmitResponse,
    handleSubmitAndHide,
    submitVoteLoading,
    isEditSelected,
    isLiveAgent,
    handleSubmitPerfectResponse,
    sourceName,
    handleCloseTicket,
    handleTagSelection,
    selectedTags,
    handleCustomFields,
    customFields,
    loadingCustomFields,
    customFieldsInput,
    shouldAddCustomFields,
    filterCustomFieldList,
    closeTicket,
    platform,
    dispatchMessageLoading
}) {

    const disableButton = !isScrollComplete || submitVoteLoading || loadingCustomFields || dispatchMessageLoading;
    sourceName = _.toString(sourceName).toLowerCase();
    const isCloseTicketSupported = supportedSourcesForCloseTicket.includes(sourceName);
    const { activeTags, loading } = useViewActiveTags();
    const shouldAddTags = !loading && isTaggingSupported(sourceName) && activeTags.length > 0;
    const hasResponse = !_.isEmpty(response);

    return(
        <Fragment>
            {
                !openEditor ?
                    <Box sx={style.defaultActionButtonContainer}>
                        <Box sx={style.editButtonContainer}>
                            <ActionButton
                                label={(loadingHtmlBody && isEditSelected) ? <CircularProgress size={15} sx={{ color: '#003300'}}/> : 'Edit'}
                                action={() => handleOpenEditor(responseId, isEditingText, msgDataSource, response)}
                                buttonBordered
                                useBorderColor={'#003300'}
                                disabled={disableButton || loadingHtmlBody}
                                withIcon={false}
                                sx={style.responseButton}
                            />
                        </Box>
                        <PerfectResponseAction
                            submitVoteLoading={submitVoteLoading}
                            handleSubmitPerfectResponse={handleSubmitPerfectResponse}
                            disableButton={disableButton}
                            loadingHtmlBody={loadingHtmlBody}
                            handleCloseTicket={handleCloseTicket}
                            closeTicket={closeTicket}
                            platform={platform}
                        />
                    </Box> :
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: '2px'}}>
                        <Box sx={{width: '84px'}}>
                            {
                                hasResponse &&
                                <ActionButton
                                    label={'Cancel'}
                                    action={() => handleCloseEditor()}
                                    buttonBordered
                                    useBorderColor={'#003300'}
                                    disabled={disableButton}
                                    withIcon={false}
                                    sx={style.responseButton}
                                />
                            }
                        </Box>
                        <Box sx={{display: 'flex', alignItems: 'center',}}>
                            {
                                isLiveAgent && canBeHidden &&
                                <Box sx={style.submitAndHideButton}>
                                    <TextButton
                                        label={'Submit and hide'}
                                        action={handleSubmitAndHide}
                                        disabled={disableButton}
                                        sx={{height: '22px'}}
                                        rootStyle={{height: '22px', color: '#003300'}}
                                    />
                                </Box>
                            }
                            <Box sx={style.actionsContainer}>
                                <Box sx={{pt: '1px', mx: '10px'}}>
                                    {
                                        isCloseTicketSupported &&
                                        <CloseTicketCheckbox handleCloseTicket={handleCloseTicket} checked={closeTicket}  />
                                    }
                                </Box>
                                {
                                    shouldAddTags &&
                                    <Box sx={{mx: '15px'}}>
                                        <TagEntry
                                            handleTagSelection={handleTagSelection}
                                            selectedTags={selectedTags}
                                            isScrollComplete={isScrollComplete}
                                        />
                                    </Box>
                                }
                                {
                                    shouldAddCustomFields &&
                                    <Box sx={{mx: '15px'}}>
                                        <CustomFieldEntry
                                            customFields={customFields}
                                            filterCustomFieldList={filterCustomFieldList}
                                            customFieldsInput={customFieldsInput}
                                            handleCustomFields={handleCustomFields}
                                            disabled={disableButton} />
                                    </Box>
                                }
                                <ActionButton
                                    label={(submitVoteLoading || dispatchMessageLoading) ? <CircularProgress size={15} sx={{ color: '#FFFFFF'}}/> : 'Submit'}
                                    action={handleSubmitResponse}
                                    disabled={disableButton}
                                    withIcon={false}
                                    sx={style.submitResponseButton}
                                />
                            </Box>
                        </Box>
                    </Box>
            }
        </Fragment>
    )
}

const style = {
    responseButton: {
        height: '32px'
    },
    submitResponseButton: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    submitAndHideButton: {
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        marginRight: '15px',
    },
    defaultActionButtonContainer: {
        width: '84px',
        display: 'flex'
    },
    editButtonContainer: {
        marginRight: '15px'
    },
    actionsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    }
}